import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { AppCtxComponent } from 'js/reactAppCtx';
import { setLocale } from 'js/localeService';


export class DesBaseCollabAcc extends HTMLElement {

    constructor(ViewModel) {
        super();
        this.ViewModel = ViewModel;
    }

    connectedCallback() {
        this.classList.add('afx-content-background');
        ReactDOM.render(
            <AppCtxComponent>{this.createReactElement()}</AppCtxComponent>,
            this
        );
    }

    getProps() {
        return {};
    }

    /**
     * Helper function
     */
     createReactElement() {
        return React.createElement(
            this.ViewModel,
            {
                accsessionid: this.accsessionid,
                locale: this.locale,
                ...this.getProps()
            },
            React.createElement('slot')
        );
    }

    get accsessionid() {
        return this.getAttribute('acc-session-id') || this.getAttribute('accsessionid');
    }
    get locale() {
        return this.getAttribute('locale');
    }

    static get observedAttributes() {
        return [ 'accsessionid', 'acc-session-id', 'locale' ];
    }

    attributeChangedCallback(name, oldValue, newValue) {
        this.debounceCreateElement();
    }

    debounceCreateElement() {
        const _this = this;
        if (_this.debounceFuncRef) {
            clearTimeout(_this.debounceFuncRef);
        }

        _this.debounceFuncRef = setTimeout(() => {
            if (_this.locale && _this.locale.length > 0) {
                setLocale(_this.locale);
            }
            window.setAfxLocale = setLocale;

            ReactDOM.render(
                <AppCtxComponent>{_this.createReactElement()}</AppCtxComponent>,
                _this
            );
        }, 1000);
    }

    disconnectedCallback() {
        ReactDOM.render(null, this);
    }
}
